import config from '@/config'

export default ($axios) => {
    return {
        /**
         * 检查当前用户口令是否在登录状态
         */
        checkUserLogin() {
            const data = {
                action: '/main/check-user-login'
            }
            return $axios.post(config.VUE_APP_BASE_API_ROUTE, data)
        },
        /**
         * 手机号登录
         */
        login(params) {
            const data = {
                params: params,
                action: '/login/index'
            }
            return $axios.post(config.VUE_APP_BASE_API_ROUTE, data)
        },
        /**
         * 退出
         */
        logout() {
            const data = {
                action: '/login/login-out'
            }
            return $axios.post(config.VUE_APP_BASE_API_ROUTE, data)
        },

           /**
         * 获取微信登录二维码
         */
        wxQrcodeTicket(tokentype, usertoken = '') {
            const data = {
                tokentype: tokentype,
                usertoken: usertoken,
                action: '/login/get-wx-login-qrcode-ticket'
            }
            return $axios.post(config.VUE_APP_BASE_API_ROUTE, data)
        },
        /**
         * 检查微信登录状态
         */
        checkWxLogintokenByTicket(token) {
            const data = {
                token: token,
                action: '/login/check-wx-login-by-ticket'
            }
            return $axios.post(config.VUE_APP_BASE_API_ROUTE, data)
        },
           /**
         * 检查微信登录状态
         */
        checkWxLogintokenAdminByTicket(token,user_token) {
            const data = {
                token: token,
                usertoken:user_token,
                action: '/login/check-wx-login-admin-by-ticket'
            }
            return $axios.post(config.VUE_APP_BASE_API_ROUTE, data)
        },
           /**
         * 发送登录验证码
         */
        sendCode(phone,  user_token = '') {
            const data = {
                phone: phone,
                user_token: user_token,
                action: '/login/send-code'
            }
            return $axios.post(config.VUE_APP_BASE_API_ROUTE, data)
        },
           /**
         * 用户绑定手机号
         */
        bindPhone(token, phone, code) {
            const data = {
                token: token,
                phone: phone,
                code: code,
                action: '/login/bind-phone'
            }
            return $axios.post(config.VUE_APP_BASE_API_ROUTE, data)
        },
    }
}